jQuery(document).ready(function($){

  getCart()


  $('body').on('click', '.custom-qty a', function(e){
    e.preventDefault()
    var val = $(this).siblings('input').val()
    val = parseInt(val)
    
    if($(this).hasClass('cq-minus')){
      val = val - 1;
      if(val <= 0){
        $(this).siblings('input').val(1)
      }else{
        $(this).siblings('input').val(val)
      }
      
    }

    if($(this).hasClass('cq-plus')){
      $(this).siblings('input').val(val + 1)
    }
  })
  $('body').on('click', '.custom-spark-layer-btn',function(e){
    e.preventDefault()
    var sku = $(this).attr('data-sku')
    var price = $(this).attr('data-price')
    var amount = $('.bdf-cred').attr('data-ra');
    var used = $('.bdf-cred').attr('data-ru');
    var qty = $(this).siblings('.custom-qty').find('input').val()
    used = parseFloat(used)
    amount = parseFloat(amount)
    price = parseFloat(price)
    $('.custom-spark-layer-btn').css('pointer-events', 'none')
    if(amount < price){
      $('.custom-spark-layer-btn').css('pointer-events', 'auto')
      alert("You don't have enough bdf balance to add this item.")
      
    }else{
      
      
      const products = {
        products: [
            {
                sku: sku,
                absoluteQuantity: parseInt(qty),
                 customAttributes: [
                      {
                      key: 'PROMO',
                      value: 'BDF',
                      }
                 ]
            }
        ],
      };
      used = used + price;
      amount = amount - price;
      // $('.remaning-amount').html('$'+amount).attr('data-amount', amount)
      // $('.remaning-used').html('$'+used).attr('data-amount', used)
      $('.bdf-cred').text(window.currencyFormatter.format((amount < 0 ? 0 : amount))).attr('data-ra', amount)
      $('.bdf-cred').text(window.currencyFormatter.format((used < 0 ? 0 : used))).attr('data-ru', used)
      window.spark.updateCart(products);
    }
    
  })
  
  function getCart(){
    $('.bdf-wrap-main').append('<div class="custom-loading custom-loading-2"><div class="lds-hourglass"></div><span>Loading BDF</span></div>');
    
    var checker = window.setInterval(function(){
        if (window.spark.getCart()) {
            window.clearInterval(checker);
            var a = window.spark.getCart().then(res => {
            var ids = []
            var discount = window.customer_bdf_discount / 100;
            var remaining = 0;
            var used = 0;
            var current_cart_total = 0;
            var current_cart_bdf_total = 0;
            // console.log(res)
            if(res.items.length > 0){
              res.items.forEach(function(val, i){
                ids.push(val.parentExternalId)
              })
      
              if(ids.length > 0){
      
                var settings = {
                  "url": "https://api.dermaquestclinical.com/product-sparklayer.php?ids=" + ids,
                  "method": "GET",
                  "timeout": 0,
                };
      
                $.ajax(settings).done(function (response) {
                  var d = JSON.parse(response)
      
                  var products = d.products
                  var b2b_ids = []
                  var computed = []
                  var bdf_total = 0;
                  if(products){
                    
                    var tags = '';
      
                    products.forEach(function(v, i){
                      pid = v.product.id
                      tags = v.product.tags.split(", ");
                      var custom_price = v.product.custom_price;
                      if(tags.length > 0){
                        if(tags.includes("b2b-main-product")){
                          res.items.forEach(function(resItem){
                            if(pid == resItem.parentExternalId && !computed.includes(resItem.sku)){
                              computed.push(resItem.sku)
                              current_cart_total = current_cart_total + resItem.lineTotal.net
                            }
                          })
                        }
                        if(tags.includes("bdf")){
                          res.items.forEach(function(resItem){
                            if(pid == resItem.parentExternalId && !computed.includes(pid)){
                              computed.push(pid)
                              b2b_ids.push({'pid': pid, 'price': resItem.lineTotal.net})
                              // console.log((parseInt(custom_price) ? parseInt(custom_price) : 0) * resItem.quantity)
                              current_cart_bdf_total = current_cart_bdf_total + ((parseFloat(custom_price) ? parseFloat(custom_price) : 0) * resItem.quantity)
                            }
                          })
                        }
                      }
                    })
      
                    var cart_compute_m = 0
                    remaining = current_cart_total * discount;
                    var cart_compute = remaining
                    remaining = remaining - current_cart_bdf_total 
                    
                    if(current_cart_total > 150){
                      $('.bdf-main-link-item').css('pointer-events', 'auto')
                    }
                    
                    if(current_cart_total < 150){
                      // console.log(remaining)
                      $('.bdf-cred').text(window.currencyFormatter.format(parseFloat(0))).attr('data-amount', parseFloat(remaining))  
                    }else{
                      // console.log(remaining + 'x')
                      $('.bdf-cred').text(window.currencyFormatter.format(parseFloat(remaining))).attr('data-amount', parseFloat(remaining))  
                    }
                    
                    var p = current_cart_total / 150 * 100;
                    $('.bg-before').css('width', p + '%')
                    $('.bdf-cred').attr('data-ra', remaining)
                    $('.bdf-cred').attr('data-ru', current_cart_bdf_total)
                    // $('.remaning-amount').text(window.currencyFormatter.format((remaining < 0 ? 0 : remaining)))
                    // $('.remaning-used').text(window.currencyFormatter.format(current_cart_bdf_total))
             
                  }
                  $('.custom-loading-2').remove()
                  $('.modal__container .custom-loading').remove()
                })
                
              }
            }
            
          })
        }
    }, 100);
    
    
    
  }
})